import React from 'react';
import { MdSpaceDashboard } from "react-icons/md";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaCalendarAlt, FaSignOutAlt } from "react-icons/fa";
import './AdminHamburguer.css';

const AdminHamburguer = ({ setSelectedComponent, handleLogout, components }) => {
  function menuOnClick() {
    document.getElementById("admin-menu-bar").classList.toggle("change");
    document.getElementById("admin-nav").classList.toggle("change");
    document.getElementById("admin-menu-bg").classList.toggle("change-bg");
    
    // Adiciona/remove classe no conteúdo principal para controlar a opacidade
    const painelContent = document.querySelector(".painelContent");
    if (painelContent) {
      painelContent.classList.toggle("menu-open");
    }
  }

  function handleOptionClick(component) {
    setSelectedComponent(component);
    
    // Fecha o menu diretamente em vez de usar menuOnClick() para evitar o efeito toggle
    document.getElementById("admin-menu-bar").classList.remove("change");
    document.getElementById("admin-nav").classList.remove("change");
    document.getElementById("admin-menu-bg").classList.remove("change-bg");
    
    // Remove a classe menu-open do conteúdo principal
    const painelContent = document.querySelector(".painelContent");
    if (painelContent) {
      painelContent.classList.remove("menu-open");
    }
  }

  return (
    <>
      <div id="admin-menu" className="admin-menu">
        <div id="admin-menu-bar" className="admin-menu-bar" onClick={menuOnClick}>
          <div id="admin-bar1" className="admin-bar"></div>
          <div id="admin-bar2" className="admin-bar"></div>
          <div id="admin-bar3" className="admin-bar"></div>
        </div>
        <nav className="admin-nav" id="admin-nav">
          <ul>
            <li>
              <a href="#" onClick={() => handleOptionClick(components.dashboards)}>
                <MdSpaceDashboard /> Dashboards
              </a>
            </li>
            <li>
              <a href="#" onClick={() => handleOptionClick(components.alunas)}>
                <BsFillPeopleFill /> Alunas
              </a>
            </li>
            <li>
              <a href="#" onClick={() => handleOptionClick(components.cronograma)}>
                <FaCalendarAlt /> Cronograma
              </a>
            </li>
            <li>
              <a href="#" onClick={handleLogout}>
                <FaSignOutAlt /> Sair
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div id="admin-menu-bg" className="admin-menu-bg"></div>
    </>
  );
};

export default AdminHamburguer;
